export default "__VITE_ASSET__DKLtwl2V__"